const textInputWithFlags = {
    tooltipText: 'tłumaczenia: '
};

export default textInputWithFlags;